import { t } from 'i18next';
import { priceTypeEnum } from '../enums';

export const priceTypeLabels: Record<number, string> = {
    [priceTypeEnum.DAY]: 'day',
    [priceTypeEnum.UNIT]: 'ride',
};

export const getPriceTypeLabel = (mode?: number): string => {
    return mode !== undefined && priceTypeLabels[mode] ? t(priceTypeLabels[mode]) : '';
};
